import React from 'react';
import PropTypes from 'prop-types';

import { View } from 'react-native-web';

import Image from '../../../shared/Image';
import Button from '../../../ui/Button';
import BodyText from '../../../ui/BodyText';
import HeaderText from '../../../ui/HeaderText';

import './Slide.module.scss';

import bolt from '../../../../../images/icons/bolt.svg';
import deposit from '../../../../../images/icons/deposit.svg';

export default function GetPaidNow({ showPaymentsButton }) {
  return (
    <View styleName="slide">
      <HeaderText styleName="slide__header" level="1">Get Paid Now</HeaderText>
      <View>
        <Image source={bolt} styleName="slide__icon" />
        <BodyText styleName="slide__copy">
          Get paid instantly, including weekends and holidays.
        </BodyText>
      </View>
      <View>
        <Image source={deposit} styleName="slide__icon slide__icon--deposit" />
        <BodyText styleName="slide__copy">
          Or, get next-business-day deposits for <strong>free.</strong>
        </BodyText>
      </View>
      { showPaymentsButton && (
        <Button
          size="medium"
          text="Get Started"
          link="provider.settings_menu.payments"
          linkParams={{ clickSource: 'growth_tab_swiper' }}
        />
      )}
    </View>
  );
}

GetPaidNow.propTypes = {
  /** boolean to show the payments setup button */
  showPaymentsButton: PropTypes.bool,
};

GetPaidNow.defaultProps = {
  showPaymentsButton: false,
};
